//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import productRangeQuery from '~/apollo/queries/product/range'
import productCategoriesQuery from '~/apollo/queries/product/categories'

export default {
  mixins: [seo],
  apollo: {
    productRange: {
      query: productRangeQuery,
      prefetch: true,
      result ({ data }) {
        this.seoTitle = data.productRange.data.attributes.pageTitle
      }
    },
    productCategories: {
      query: productCategoriesQuery,
      prefetch: true
    }
  }
}

